import { graphql } from 'src/gql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQL } from 'src/hooks/useGraphQL'

const document = graphql(/* graphql */`
  query lookupConfigs {
    lookups {
      config {
        many {
          _id
          name
          fields {
            title
            key
            component {
              type
              props
            }
          }
          optionsCount
          relationships {
            model
            title
            key
            link
          }
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type LookupConfigs = NonNullable<NonNullable<NonNullable<NonNullable<TData>['lookups']>['config']>['many']>

const useLookupConfigs = (): LookupConfigs | undefined => {
  const { data } = useGraphQL(document)
  return data?.lookups?.config?.many ?? []
}

export { useLookupConfigs, document as lookupConfigsDocument }
